import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=64e90e4d&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"
import style0 from "./Notification.vue?vue&type=style&index=0&id=64e90e4d&lang=scss&scoped=true&"
import style1 from "./Notification.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e90e4d",
  null
  
)

export default component.exports